import { ShieldCheck } from 'lucide-react';
import { DiscardChangesDialog } from '@/components/common/DiscardChangesDialog';
import {
  FormDialog,
  FormSection,
  FormStatusField,
  FormTextareaField,
  FormTextField,
} from '@/components/common/FormDialog';
import { useRoleForm } from '../hooks/useRoleForm';
import type { Role } from '../types/role.types';

interface RoleFormModalProps {
  role: Role | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RoleFormModal({ role, open, onOpenChange }: RoleFormModalProps) {
  const {
    form,
    isEditMode,
    isPending,
    submit,
    isDiscardDialogOpen,
    requestClose,
    confirmDiscard,
    cancelDiscard,
  } = useRoleForm({ role, open, onClose: () => onOpenChange(false) });

  function handleOpenChange(nextOpen: boolean) {
    if (!nextOpen) {
      requestClose();
      return;
    }
    onOpenChange(nextOpen);
  }

  return (
    <>
      <FormDialog
        open={open}
        onOpenChange={handleOpenChange}
        icon={ShieldCheck}
        title={isEditMode ? 'Edit Role' : 'Add Role'}
        description="A role is what users are given to reach their pages."
        form={form}
        isPending={isPending}
        isEditMode={isEditMode}
        onSubmit={submit}
      >
        <FormSection>
          {isEditMode ? null : (
            <FormTextField
              control={form.control}
              name="code"
              label="Code"
              placeholder="AREA_MANAGER"
              isUpperCase
            />
          )}
          <FormTextField
            control={form.control}
            name="name"
            label="Role Name"
            placeholder="Area Manager"
          />
          <FormTextareaField
            control={form.control}
            name="description"
            label="Details"
            placeholder="What this role is for"
            isFullRow
          />
        </FormSection>
        <FormStatusField control={form.control} name="isActive" />
      </FormDialog>

      <DiscardChangesDialog
        open={isDiscardDialogOpen}
        onOpenChange={(nextOpen) => !nextOpen && cancelDiscard()}
        onDiscard={confirmDiscard}
      />
    </>
  );
}
